import type { FPCEventTypes, ViewContentEventType } from 'util/facebookAnalytics/types';

export const trackEvent = (
  type: string = 'track',
  eventType: FPCEventTypes,
  contentType: string,
  contents: string,
  contentIds: string[] | null,
  contentName: string | null,
  contentCategory: string,
) => {
  (window as any).fbq(
    type,
    eventType, {
      content_type: contentType,
      contents,
      content_ids: contentIds,
      content_name: contentName,
      content_category: contentCategory,
    },
  );
};

export const trackViewContentEvent = (
  type: ViewContentEventType,
  data: string,
  ids: string[] | null,
  name: string | null,
  category: string,
) => {
  trackEvent(
    'track',
    'ViewContent',
    type,
    data,
    ids,
    name,
    category,
  );
};
